// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-gradient: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  --secondary-gradient: linear-gradient(135deg, #f857a6 0%, #ff5858 100%);
  --success-gradient: linear-gradient(135deg, #00b09b 0%, #96c93d 100%);
  --header-gradient: linear-gradient(135deg, #4776e6 0%, #8e54e9 100%);
  --card-gradient: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.08);
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 8px 30px rgba(0, 0, 0, 0.12);
  --shadow-xl: 0 12px 40px rgba(0, 0, 0, 0.15);
  --border-radius-sm: 8px;
  --border-radius-md: 12px;
  --border-radius-lg: 20px;
  --border-radius-xl: 30px;
  --transition-fast: 0.2s ease;
  --transition-normal: 0.3s ease;
  --transition-slow: 0.5s ease;
  --font-primary: "Poppins", "Inter", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, sans-serif;
  --color-text-primary: #1e293b;
  --color-text-secondary: #64748b;
  --color-text-tertiary: #94a3b8;
  --color-bg-primary: #ffffff;
  --color-bg-secondary: #f8fafc;
  --color-bg-tertiary: #f1f5f9;
  --color-border: #e2e8f0;
  --color-primary: #6a11cb;
  --color-secondary: #f857a6;
  --color-success: #00b09b;
  --color-danger: #ff5858;
  --color-warning: #ffd166;
  --color-info: #4facfe;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  font-family: var(--font-primary);
  background: var(--color-bg-secondary);
  color: var(--color-text-primary);
  line-height: 1.6;
}

/* Container */
.MaterialPurches-container {
  max-width: 1400px;
  margin: 0 auto;
  /* padding: 24px; */
  min-height: 100vh;
}

/* Enhanced Header */

.MaterialPurches-header {
  /* background: linear-gradient(135deg, #4c1d95 0%, #7c3aed 100%); */
  background: linear-gradient(135deg, #7a9d96 100%, #cae4db 0%);
  padding: 11px 20px;
  color: white;
  text-align: center;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  margin-bottom: 40px;
}

.MaterialPurches-header::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.15) 0%,
    transparent 60%
  );
  animation: pulse 15s infinite linear;
}

@keyframes pulse {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.MaterialPurches-header-content {
  position: relative;
  z-index: 2;
}

.MaterialPurches-title {
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 12px;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.MaterialPurches-subtitle {
  font-size: 18px;
  font-weight: 400;
  opacity: 0.9;
  text-align: center;
}

/* Enhanced Search Section */
.MaterialPurches-headerSection {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  margin-bottom: 32px;
  flex-wrap: wrap;
}

.print_button_material_purches {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  /* margin-top: 5px; */
}

.MaterialPurches-searchContainer {
  flex: 1 1;
  display: flex;
  justify-content: space-between;
}

.MaterialPurches-searchWrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 50%;
}

.MaterialPurches-searchIcon {
  position: absolute;
  left: 16px;
  color: var(--color-text-secondary);
  z-index: 1;
}

.MaterialPurches-searchBar {
  width: 100%;
  /* padding: 16px 16px 16px 48px; */
  padding: 12px 40px;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-md);
  font-size: 1rem;
  font-family: var(--font-primary);
  background: var(--color-bg-primary);
  transition: var(--transition-normal);
  box-shadow: var(--shadow-sm);
}

.MaterialPurches-searchBar:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 4px rgba(106, 17, 203, 0.1);
}

.MaterialPurches-toggleFormButton {
  background: #14b8a6;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: var(--border-radius-md);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-normal);
  box-shadow: var(--shadow-md);
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.MaterialPurches-toggleFormButton:hover {
  transform: translateY(-2px);
  /* box-shadow: var(--shadow-lg); */
}

.MaterialPurches-buttonIcon {
  width: 20px;
  height: 20px;
}

/* Enhanced Form Modal */
.MaterialPurches-formOverlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 24px;
  backdrop-filter: blur(8px);
}

.MaterialPurches-formContainer {
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-xl);
  width: 100%;
  max-width: 1000px;
  max-height: 90vh;
  overflow-y: auto;
  animation: slideInUp 0.4s ease;
  scrollbar-width: none;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.MaterialPurches-formHeader {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 9px 4px 9px 9px;
  border-bottom: 1px solid var(--color-border);
  background: var(--card-gradient);
  border-radius: var(--border-radius-lg) var(--border-radius-lg) 0 0;
}

.MaterialPurches-formHeaderContent {
  flex: 1 1;
}

.MaterialPurches-formTitle {
  font-size: 1.75rem;
  font-weight: 700;
  margin: 0 0 8px 0;
  color: var(--color-text-primary);
}

.MaterialPurches-formSubtitle {
  font-size: 1rem;
  color: var(--color-text-secondary);
  margin: 0;
}

.MaterialPurches-closeFormButton {
  background: var(--color-bg-tertiary);
  border: none;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  cursor: pointer;
  color: var(--color-text-secondary);
  transition: var(--transition-fast);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 16px;
}

.MaterialPurches-closeFormButton:hover {
  background: var(--color-border);
  color: var(--color-text-primary);
  transform: scale(1.05);
}

.MaterialPurches-form {
  padding: 12px;
}

.MaterialPurches-formGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
}

.MaterialPurches-formGroup {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.MaterialPurches-label {
  font-weight: 600;
  color: var(--color-text-primary);
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  gap: 8px;
}

.MaterialPurches-labelIcon {
  color: var(--color-text-secondary);
}

.MaterialPurches-input,
.MaterialPurches-textarea {
  padding: 14px 16px;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-sm);
  font-size: 1rem;
  font-family: var(--font-primary);
  background: var(--color-bg-primary);
  transition: var(--transition-normal);
}

.MaterialPurches-input:focus,
.MaterialPurches-textarea:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 4px rgba(106, 17, 203, 0.1);
}

.MaterialPurches-textarea {
  resize: vertical;
  min-height: 100px;
}

.MaterialPurches-selectWrapper {
  position: relative;
}

.MaterialPurches-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 48px;
  cursor: pointer;
}

.MaterialPurches-selectArrow {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: var(--color-text-secondary);
}

/* Enhanced Order Items Section */
.MaterialPurches-orderItemsSection {
  margin: 32px 0;
  padding: 32px;
  background: var(--color-bg-tertiary);
  border-radius: var(--border-radius-lg);
  border: 1px solid var(--color-border);
}

.MaterialPurches-orderItemsHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.MaterialPurches-orderItemsHeaderContent {
  display: flex;
  align-items: center;
  gap: 12px;
}

.MaterialPurches-orderItemsTitle {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  color: var(--color-text-primary);
}

.MaterialPurches-itemsCount {
  /* background: var(--color-primary); */
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
  color: white;
  padding: 4px 12px;
  border-radius: var(--border-radius-xl);
  font-size: 0.85rem;
  font-weight: 600;
}

.MaterialPurches-addItemButton {
  /* background: var(--success-gradient); */
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: var(--border-radius-sm);
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-normal);
  box-shadow: var(--shadow-sm);
  display: flex;
  align-items: center;
  gap: 8px;
}

.MaterialPurches-addItemButton:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.MaterialPurches-orderItemsList {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.MaterialPurches-orderItemCard {
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-md);
  padding: 10px;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--color-border);
  transition: var(--transition-normal);
}

.MaterialPurches-orderItemCard:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

.MaterialPurches-orderItemHeader {
  display: flex;
  justify-content: end;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--color-border);
}

.MaterialPurches-itemNumber {
  background: var(--primary-gradient);
  color: white;
  padding: 6px 12px;
  border-radius: var(--border-radius-xl);
  font-size: 0.85rem;
  font-weight: 600;
}

.MaterialPurches-orderItemRow {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 10px;
  align-items: end;
}

.MaterialPurches-orderItemField {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.MaterialPurches-itemLabel {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--color-text-secondary);
}

.MaterialPurches-itemInput {
  padding: 12px 14px;
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius-sm);
  font-size: 0.95rem;
  font-family: var(--font-primary);
  background: var(--color-bg-primary);
  transition: var(--transition-fast);
}

.MaterialPurches-itemInput:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);
}

.MaterialPurches-itemTotal {
  padding: 12px 14px;
  /* background: var(--success-gradient); */
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
  color: white;
  border-radius: var(--border-radius-sm);
  font-weight: 700;
  text-align: center;
  font-size: 1rem;
}

.MaterialPurches-removeItemButton {
  /* background: var(--color-danger); */
  color: red;
  border: none;
  /* width: 40px; */
  /* height: 40px; */
  /* border-radius: 50%; */
  cursor: pointer;
  transition: var(--transition-fast);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* .MaterialPurches-removeItemButton:hover {
  background: #e53e3e;
  transform: scale(1.1);
} */

.MaterialPurches-orderSummary {
  margin-top: 24px;
  padding: 20px;
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-md);
  border: 2px solid var(--color-success);
}

.MaterialPurches-summaryRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.MaterialPurches-summaryLabel {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--color-text-primary);
}

.MaterialPurches-summaryValue {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--color-success);
}

/* Form Actions */
.MaterialPurches-formActions {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid var(--color-border);
}

.MaterialPurches-cancelButton {
  background: var(--color-bg-tertiary);
  color: var(--color-text-secondary);
  border: 2px solid var(--color-border);
  padding: 14px 28px;
  border-radius: var(--border-radius-sm);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-normal);
}

.MaterialPurches-cancelButton:hover {
  background: var(--color-border);
  color: var(--color-text-primary);
}

.MaterialPurches-submitButton {
  /* background: var(--primary-gradient); */
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
  color: white;
  border: none;
  padding: 14px 28px;
  border-radius: var(--border-radius-sm);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-normal);
  box-shadow: var(--shadow-md);
  display: flex;
  align-items: center;
  gap: 8px;
}

.MaterialPurches-submitButton:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

/* Enhanced View Modal - Redesigned Simple Table View */
.MaterialPurches-viewOverlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 24px;
  backdrop-filter: blur(8px);
}

.MaterialPurches-viewContainer {
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-xl);
  width: 100%;
  max-width: 1000px;
  max-height: 90vh;
  overflow-y: auto;
  animation: slideInUp 0.4s ease;
}

.MaterialPurches-viewHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 32px;
  border-bottom: 1px solid var(--color-border);
  background: var(--card-gradient);
  border-radius: var(--border-radius-lg) var(--border-radius-lg) 0 0;
}

.print-header {
  flex: 1 1;
}

.print-title {
  font-size: 1.75rem;
  font-weight: 700;
  margin: 0 0 8px 0;
  color: var(--color-text-primary);
}

.print-subtitle {
  font-size: 1rem;
  color: var(--color-text-secondary);
  margin: 0;
}

.print-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.MaterialPurches-printButton {
  /* background: var(--success-gradient); */
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: var(--border-radius-sm);
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-normal);
  box-shadow: var(--shadow-sm);
  display: flex;
  align-items: center;
  gap: 8px;
}

.MaterialPurches-printButton:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.MaterialPurches-closeViewButton {
  background: var(--color-bg-tertiary);
  border: none;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  cursor: pointer;
  color: var(--color-text-secondary);
  transition: var(--transition-fast);
  display: flex;
  align-items: center;
  justify-content: center;
}

.MaterialPurches-closeViewButton:hover {
  background: var(--color-border);
  color: var(--color-text-primary);
  transform: scale(1.05);
}

.MaterialPurches-viewContent {
  padding: 32px;
}

/* Order Information Section */
.order-info {
  margin-bottom: 32px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}
.info-item {
  display: flex;
  align-items: center;
  /* padding: 16px; */
  /* background: var(--color-bg-tertiary); */
  /* border-radius: var(--border-radius-sm); */
  /* border-left: 4px solid var(--color-primary); */
  flex-direction: column;
}

.info-label {
  font-weight: 600;
  color: var(--color-text-secondary);
  min-width: 120px;
  font-size: 0.9rem;
}

.info-value {
  font-weight: 600;
  color: var(--color-text-primary);
  font-size: 1rem;
}

.status-badge {
  padding: 6px 12px;
  border-radius: var(--border-radius-xl);
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-pending {
  background: rgba(255, 209, 102, 0.2);
  color: #b45309;
  border: 1px solid rgba(180, 83, 9, 0.3);
}

.status-delivered {
  background: rgba(0, 176, 155, 0.2);
  color: #00b09b;
  border: 1px solid rgba(0, 176, 155, 0.3);
}

.status-cancelled {
  background: rgba(255, 88, 88, 0.2);
  color: #ff5858;
  border: 1px solid rgba(255, 88, 88, 0.3);
}

.status-received {
  background: rgba(34, 197, 94, 0.2);
  color: #16a34a;
  border: 1px solid rgba(34, 197, 94, 0.3);
}

.note-section {
  text-align: start;
}

.note-title {
  font-weight: 600;
  color: var(--color-text-primary);
  margin-bottom: 8px;
  font-size: 1rem;
}

.note-content {
  color: var(--color-text-secondary);
  line-height: 1.6;
  font-size: 0.95rem;
}

/* Items Table Section */
.MaterialPurches-itemsTableSection {
  margin-top: 32px;
}

.MaterialPurches-itemsTableTitle {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 20px 0;
  color: var(--color-text-primary);
}

.MaterialPurches-itemsTableWrapper {
  overflow-x: auto;
  border-radius: var(--border-radius-sm);
  box-shadow: var(--shadow-sm);
}

.items-table {
  width: 100%;
  border-collapse: collapse;
  background: var(--color-bg-primary);
  font-family: var(--font-primary);
}

.items-table thead {
  background: var(--color-bg-tertiary);
}

.items-table th {
  padding: 16px 12px;
  text-align: left;
  font-weight: 700;
  color: var(--color-text-primary);
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid var(--color-border);
}

.items-table td {
  padding: 16px 12px;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-text-primary);
  font-size: 0.95rem;
  vertical-align: middle;
}

.items-table tbody tr:hover {
  background: var(--color-bg-tertiary);
}

.MaterialPurches-materialName {
  font-weight: 600;
  color: var(--color-text-primary);
}

.MaterialPurches-itemStatusSelect {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: white;
  border: 2px solid var(--color-border);
  padding: 6px 24px 6px 10px;
  border-radius: var(--border-radius-sm);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-normal);
  min-width: 100px;
}

.MaterialPurches-itemStatusSelect:focus {
  outline: none;
  /* border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1); */
}

.MaterialPurches-itemStatusSelect.status-pending {
  color: #000000;
  /* background: rgba(255, 209, 102, 0.1); */
  /* border-color: rgba(180, 83, 9, 0.3); */
}

.MaterialPurches-itemStatusSelect.status-received {
  color: #000000;
  /* background: rgba(34, 197, 94, 0.1);
  border-color: rgba(34, 197, 94, 0.3); */
}

.MaterialPurches-itemDeleteButton {
  /* background: var(--color-danger); */
  color: rgb(0, 0, 0);
  border: none;
  padding: 8px;
  border-radius: var(--border-radius-sm);
  cursor: pointer;
  transition: var(--transition-fast);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}

.MaterialPurches-itemDeleteButton:hover {
  /* background: #e53e3e; */
  transform: scale(1.1);
}

.total-row {
  background: var(--color-bg-tertiary);
  font-weight: 700;
  border-top: 2px solid var(--color-border);
}

.total-row td {
  padding: 20px 12px;
  font-size: 1.1rem;
}

/* Enhanced Table */
.MaterialPurches-tableContainer {
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  overflow: hidden;
  border: 1px solid var(--color-border);
}

.MaterialPurches-tableHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 32px;
  background: var(--card-gradient);
  border-bottom: 1px solid var(--color-border);
}

.MaterialPurches-tableTitle {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  color: var(--color-text-primary);
}

.MaterialPurches-tableStats {
  display: flex;
  align-items: center;
  gap: 16px;
}

.MaterialPurches-tableStatsText {
  font-size: 0.9rem;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.MaterialPurches-tableWrapper {
  overflow-x: auto;
}

.MaterialPurches-table {
  width: 100%;
  border-collapse: collapse;
  font-family: var(--font-primary);
}

.MaterialPurches-tableHead {
  background: var(--color-bg-tertiary);
}

.MaterialPurches-tableHeaderCell {
  padding: 20px 16px;
  /* text-align: left; */
  font-weight: 700;
  color: var(--color-text-primary);
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid var(--color-border);
}

.MaterialPurches-tableBody .MaterialPurches-tableRow {
  transition: var(--transition-fast);
  border-bottom: 1px solid var(--color-border);
}

.MaterialPurches-tableBody .MaterialPurches-tableRow:hover {
  background: var(--color-bg-tertiary);
}

.MaterialPurches-tableCell {
  padding: 10px 16px;
  color: var(--color-text-primary);
  font-size: 0.95rem;
  vertical-align: middle;
}

.MaterialPurches-poNumberCell,
.MaterialPurches-supplierCell,
.MaterialPurches-siteCell,
.MaterialPurches-dateCell {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

.MaterialPurches-poNumber {
  font-weight: 700;
  /* color: var(--color-primary); */
  color: #0d5787;
  font-size: 1rem;
}

.MaterialPurches-supplierCell svg,
.MaterialPurches-siteCell svg,
.MaterialPurches-dateCell svg {
  color: #ffffff;
}
.MaterialPurches-supplierCell {
  /* background-color: #00b09b42; */
  background: #14b8a6;
  padding: 6px 0px;
  border-radius: 50px;
  color: #ffffff;
  font-weight: 600;
}
.MaterialPurches-statusSelectWrapper {
  position: relative;
  display: inline-block;
}

.MaterialPurches-statusSelect {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: white;
  border: 2px solid var(--color-border);
  padding: 8px 32px 8px 12px;
  border-radius: var(--border-radius-sm);
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-normal);
  min-width: 120px;
}

.MaterialPurches-statusSelect:focus {
  outline: none;
}

.MaterialPurches-statusSelect.MaterialPurches-status-pending {
  color: #000000;
}

.MaterialPurches-statusSelect.MaterialPurches-status-delivered {
  color: #000000;
}

.MaterialPurches-statusSelect.MaterialPurches-status-cancelled {
  color: #000000;
}

.MaterialPurches-statusSelectArrow {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: var(--color-text-secondary);
}

.MaterialPurches-actionsCell {
  white-space: nowrap;
}

.MaterialPurches-actionButtons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.MaterialPurches-viewButton,
.MaterialPurches-editButton,
.MaterialPurches-deleteButton {
  padding: 10px;

  border-radius: var(--border-radius-sm);
  cursor: pointer;
  transition: var(--transition-fast);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}

.MaterialPurches-viewButton {
  /* background: var(--color-info); */
  outline: none;
  border: none;
  background: rgba(59, 130, 246, 0.1);
  color: #10b981;
  background: #10b98141;
}

.MaterialPurches-viewButton:hover {
  background: #10b981;
  transform: translateY(-2px);
  /* box-shadow: var(--shadow-sm); */
  border-color: red;
  color: white;
}

.MaterialPurches-editButton {
  /* background: var(--color-warning); */
  color: #3b82f6;
  outline: none;
  border: none;
  background: rgba(59, 131, 246, 0.274);
}

.MaterialPurches-editButton:hover {
  background: #3b82f6;
  transform: translateY(-2px);
  color: white;
  /* box-shadow: var(--shadow-sm); */
}

.MaterialPurches-deleteButton {
  /* background: var(--color-danger); */
  color: #ef4444;
  outline: none;
  border: none;
  background: #ef444444;
}

.MaterialPurches-deleteButton:hover {
  background: #ef4444;
  transform: translateY(-2px);
  color: white;
  box-shadow: var(--shadow-sm);
}

.MaterialPurches-noData {
  text-align: center;
  padding: 80px 20px;
}

.MaterialPurches-noDataContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  color: var(--color-text-secondary);
}

.MaterialPurches-noDataIcon {
  color: var(--color-text-tertiary);
  opacity: 0.5;
}

.MaterialPurches-noDataText h3 {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: var(--color-text-secondary);
}

.MaterialPurches-noDataText p {
  font-size: 0.95rem;
  margin: 0;
  color: var(--color-text-tertiary);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .MaterialPurches-headerContent {
    flex-direction: column;
    gap: 24px;
    text-align: center;
  }
}

@media (max-width: 768px) {
  .MaterialPurches-container {
    /* padding: 16px; */
  }

  .MaterialPurches-header {
    padding: 24px 20px;
  }

  .MaterialPurches-title {
    font-size: 2rem;
  }

  .MaterialPurches-headerSection {
    flex-direction: column;
    align-items: stretch;
  }

  .MaterialPurches-searchContainer {
    max-width: none;
  }

  .MaterialPurches-formGrid {
    grid-template-columns: 1fr;
  }

  .MaterialPurches-orderItemRow {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .info-grid {
    /* grid-template-columns: 1fr; */
  }

  .MaterialPurches-actionButtons {
    flex-direction: column;
    gap: 8px;
  }

  .MaterialPurches-formActions {
    flex-direction: column;
  }

  .MaterialPurches-tableHeader {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }

  .items-table {
    font-size: 0.85rem;
  }

  .items-table th,
  .items-table td {
    padding: 12px 8px;
  }
}

@media (max-width: 480px) {
  .MaterialPurches-header {
    padding: 20px 16px;
  }

  .MaterialPurches-title {
    font-size: 1.8rem;
  }

  .MaterialPurches-subtitle {
    font-size: 0.95rem;
  }

  .MaterialPurches-formOverlay,
  .MaterialPurches-viewOverlay {
    padding: 16px;
  }

  .MaterialPurches-form,
  .MaterialPurches-viewContent {
    padding: 24px;
  }

  .MaterialPurches-tableHeaderCell,
  .MaterialPurches-tableCell {
    padding: 12px 8px;
    font-size: 0.85rem;
  }

  .MaterialPurches-actionButtons {
    flex-direction: row;
    gap: 4px;
  }

  .MaterialPurches-viewButton,
  .MaterialPurches-editButton,
  .MaterialPurches-deleteButton {
    width: 36px;
    height: 36px;
  }

  .print-actions {
    flex-direction: column;
    gap: 8px;
  }
}

/* Print Styles */
@media print {
  .print-actions {
    display: none !important;
  }

  .MaterialPurches-itemDeleteButton {
    display: none !important;
  }

  .MaterialPurches-actionsCell {
    display: none !important;
  }

  .MaterialPurches-tableHeaderCell:nth-child(6) {
    display: none !important;
  }

  .items-table th:last-child,
  .items-table td:last-child {
    display: none !important;
  }

  body {
    background: white !important;
  }

  .MaterialPurches-viewContainer {
    box-shadow: none !important;
    border: 1px solid #ddd !important;
  }
}

.Site_name {
  padding: 4px 10px;
  border-radius: 6px;
  font-weight: 500;
  display: inline-block;
  background-color: #00b09b;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Material/MaterialPurches.css"],"names":[],"mappings":"AAAA;EACE,qEAAqE;EACrE,uEAAuE;EACvE,qEAAqE;EACrE,oEAAoE;EACpE,kEAAkE;EAClE,0CAA0C;EAC1C,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;EAC5C,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B;kCACgC;EAChC,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,qCAAqC;EACrC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,oBAAoB;;AAEpB;EACE,mEAAmE;EACnE,6DAA6D;EAC7D,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;;;GAIC;EACD,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,qCAAqC;EACrC,sCAAsC;EACtC,eAAe;EACf,gCAAgC;EAChC,mCAAmC;EACnC,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,4BAA4B;EAC5B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;EACxB,4CAA4C;EAC5C,gCAAgC;EAChC,kEAAkE;AACpE;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,kBAAkB;EAClB,qCAAqC;EACrC,sCAAsC;EACtC,eAAe;EACf,gCAAgC;EAChC,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA,iCAAiC;AACjC;EACE,cAAc;EACd,aAAa;EACb,oCAAoC;EACpC,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,gCAAgC;EAChC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,6DAA6D;EAC7D,YAAY;EACZ,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;GAGG;;AAEH;EACE,gBAAgB;EAChB,aAAa;EACb,mCAAmC;EACnC,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,qCAAqC;EACrC,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;EACzC,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,4BAA4B;EAC5B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,4CAA4C;EAC5C,gCAAgC;EAChC,kEAAkE;AACpE;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,4CAA4C;EAC5C,iDAAiD;EACjD,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,qCAAqC;EACrC,0BAA0B;EAC1B,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb;kDACgD;AAClD;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd;yCACuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,mCAAmC;EACnC,sCAAsC;EACtC,4BAA4B;EAC5B,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,qCAAqC;EACrC,0BAA0B;EAC1B,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;;EAEb,sCAAsC;EACtC,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,YAAY;EACZ,mCAAmC;EACnC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,kCAAkC;EAClC,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,aAAa;EACb,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,QAAQ;EACV;;EAEA;;;IAGE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;IAC3B,iCAAiC;EACnC;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;AACd","sourcesContent":[":root {\n  --primary-gradient: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);\n  --secondary-gradient: linear-gradient(135deg, #f857a6 0%, #ff5858 100%);\n  --success-gradient: linear-gradient(135deg, #00b09b 0%, #96c93d 100%);\n  --header-gradient: linear-gradient(135deg, #4776e6 0%, #8e54e9 100%);\n  --card-gradient: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.08);\n  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 8px 30px rgba(0, 0, 0, 0.12);\n  --shadow-xl: 0 12px 40px rgba(0, 0, 0, 0.15);\n  --border-radius-sm: 8px;\n  --border-radius-md: 12px;\n  --border-radius-lg: 20px;\n  --border-radius-xl: 30px;\n  --transition-fast: 0.2s ease;\n  --transition-normal: 0.3s ease;\n  --transition-slow: 0.5s ease;\n  --font-primary: \"Poppins\", \"Inter\", -apple-system, BlinkMacSystemFont,\n    \"Segoe UI\", Roboto, sans-serif;\n  --color-text-primary: #1e293b;\n  --color-text-secondary: #64748b;\n  --color-text-tertiary: #94a3b8;\n  --color-bg-primary: #ffffff;\n  --color-bg-secondary: #f8fafc;\n  --color-bg-tertiary: #f1f5f9;\n  --color-border: #e2e8f0;\n  --color-primary: #6a11cb;\n  --color-secondary: #f857a6;\n  --color-success: #00b09b;\n  --color-danger: #ff5858;\n  --color-warning: #ffd166;\n  --color-info: #4facfe;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: var(--font-primary);\n  background: var(--color-bg-secondary);\n  color: var(--color-text-primary);\n  line-height: 1.6;\n}\n\n/* Container */\n.MaterialPurches-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  /* padding: 24px; */\n  min-height: 100vh;\n}\n\n/* Enhanced Header */\n\n.MaterialPurches-header {\n  /* background: linear-gradient(135deg, #4c1d95 0%, #7c3aed 100%); */\n  background: linear-gradient(135deg, #7a9d96 100%, #cae4db 0%);\n  padding: 11px 20px;\n  color: white;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  margin-bottom: 40px;\n}\n\n.MaterialPurches-header::before {\n  content: \"\";\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: radial-gradient(\n    circle,\n    rgba(255, 255, 255, 0.15) 0%,\n    transparent 60%\n  );\n  animation: pulse 15s infinite linear;\n}\n\n@keyframes pulse {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.MaterialPurches-header-content {\n  position: relative;\n  z-index: 2;\n}\n\n.MaterialPurches-title {\n  font-size: 28px;\n  font-weight: 800;\n  margin-bottom: 12px;\n  letter-spacing: -0.5px;\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.MaterialPurches-subtitle {\n  font-size: 18px;\n  font-weight: 400;\n  opacity: 0.9;\n  text-align: center;\n}\n\n/* Enhanced Search Section */\n.MaterialPurches-headerSection {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 24px;\n  margin-bottom: 32px;\n  flex-wrap: wrap;\n}\n\n.print_button_material_purches {\n  display: flex;\n  gap: 5px;\n  flex-wrap: wrap;\n  /* margin-top: 5px; */\n}\n\n.MaterialPurches-searchContainer {\n  flex: 1;\n  display: flex;\n  justify-content: space-between;\n}\n\n.MaterialPurches-searchWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 50%;\n}\n\n.MaterialPurches-searchIcon {\n  position: absolute;\n  left: 16px;\n  color: var(--color-text-secondary);\n  z-index: 1;\n}\n\n.MaterialPurches-searchBar {\n  width: 100%;\n  /* padding: 16px 16px 16px 48px; */\n  padding: 12px 40px;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-md);\n  font-size: 1rem;\n  font-family: var(--font-primary);\n  background: var(--color-bg-primary);\n  transition: var(--transition-normal);\n  box-shadow: var(--shadow-sm);\n}\n\n.MaterialPurches-searchBar:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 4px rgba(106, 17, 203, 0.1);\n}\n\n.MaterialPurches-toggleFormButton {\n  background: #14b8a6;\n  color: white;\n  border: none;\n  padding: 8px 15px;\n  border-radius: var(--border-radius-md);\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition-normal);\n  box-shadow: var(--shadow-md);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n.MaterialPurches-toggleFormButton:hover {\n  transform: translateY(-2px);\n  /* box-shadow: var(--shadow-lg); */\n}\n\n.MaterialPurches-buttonIcon {\n  width: 20px;\n  height: 20px;\n}\n\n/* Enhanced Form Modal */\n.MaterialPurches-formOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 24px;\n  backdrop-filter: blur(8px);\n}\n\n.MaterialPurches-formContainer {\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-xl);\n  width: 100%;\n  max-width: 1000px;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: slideInUp 0.4s ease;\n  scrollbar-width: none;\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(40px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.MaterialPurches-formHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 9px 4px 9px 9px;\n  border-bottom: 1px solid var(--color-border);\n  background: var(--card-gradient);\n  border-radius: var(--border-radius-lg) var(--border-radius-lg) 0 0;\n}\n\n.MaterialPurches-formHeaderContent {\n  flex: 1;\n}\n\n.MaterialPurches-formTitle {\n  font-size: 1.75rem;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  color: var(--color-text-primary);\n}\n\n.MaterialPurches-formSubtitle {\n  font-size: 1rem;\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n.MaterialPurches-closeFormButton {\n  background: var(--color-bg-tertiary);\n  border: none;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  cursor: pointer;\n  color: var(--color-text-secondary);\n  transition: var(--transition-fast);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 16px;\n}\n\n.MaterialPurches-closeFormButton:hover {\n  background: var(--color-border);\n  color: var(--color-text-primary);\n  transform: scale(1.05);\n}\n\n.MaterialPurches-form {\n  padding: 12px;\n}\n\n.MaterialPurches-formGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n.MaterialPurches-formGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.MaterialPurches-label {\n  font-weight: 600;\n  color: var(--color-text-primary);\n  font-size: 0.95rem;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.MaterialPurches-labelIcon {\n  color: var(--color-text-secondary);\n}\n\n.MaterialPurches-input,\n.MaterialPurches-textarea {\n  padding: 14px 16px;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-sm);\n  font-size: 1rem;\n  font-family: var(--font-primary);\n  background: var(--color-bg-primary);\n  transition: var(--transition-normal);\n}\n\n.MaterialPurches-input:focus,\n.MaterialPurches-textarea:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 4px rgba(106, 17, 203, 0.1);\n}\n\n.MaterialPurches-textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.MaterialPurches-selectWrapper {\n  position: relative;\n}\n\n.MaterialPurches-select {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  padding-right: 48px;\n  cursor: pointer;\n}\n\n.MaterialPurches-selectArrow {\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: var(--color-text-secondary);\n}\n\n/* Enhanced Order Items Section */\n.MaterialPurches-orderItemsSection {\n  margin: 32px 0;\n  padding: 32px;\n  background: var(--color-bg-tertiary);\n  border-radius: var(--border-radius-lg);\n  border: 1px solid var(--color-border);\n}\n\n.MaterialPurches-orderItemsHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.MaterialPurches-orderItemsHeaderContent {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.MaterialPurches-orderItemsTitle {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0;\n  color: var(--color-text-primary);\n}\n\n.MaterialPurches-itemsCount {\n  /* background: var(--color-primary); */\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n  color: white;\n  padding: 4px 12px;\n  border-radius: var(--border-radius-xl);\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.MaterialPurches-addItemButton {\n  /* background: var(--success-gradient); */\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: var(--border-radius-sm);\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition-normal);\n  box-shadow: var(--shadow-sm);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.MaterialPurches-addItemButton:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.MaterialPurches-orderItemsList {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.MaterialPurches-orderItemCard {\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-md);\n  padding: 10px;\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--color-border);\n  transition: var(--transition-normal);\n}\n\n.MaterialPurches-orderItemCard:hover {\n  box-shadow: var(--shadow-md);\n  transform: translateY(-2px);\n}\n\n.MaterialPurches-orderItemHeader {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.MaterialPurches-itemNumber {\n  background: var(--primary-gradient);\n  color: white;\n  padding: 6px 12px;\n  border-radius: var(--border-radius-xl);\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.MaterialPurches-orderItemRow {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr 1fr;\n  gap: 10px;\n  align-items: end;\n}\n\n.MaterialPurches-orderItemField {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.MaterialPurches-itemLabel {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n}\n\n.MaterialPurches-itemInput {\n  padding: 12px 14px;\n  border: 1px solid var(--color-border);\n  border-radius: var(--border-radius-sm);\n  font-size: 0.95rem;\n  font-family: var(--font-primary);\n  background: var(--color-bg-primary);\n  transition: var(--transition-fast);\n}\n\n.MaterialPurches-itemInput:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);\n}\n\n.MaterialPurches-itemTotal {\n  padding: 12px 14px;\n  /* background: var(--success-gradient); */\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n  color: white;\n  border-radius: var(--border-radius-sm);\n  font-weight: 700;\n  text-align: center;\n  font-size: 1rem;\n}\n\n.MaterialPurches-removeItemButton {\n  /* background: var(--color-danger); */\n  color: red;\n  border: none;\n  /* width: 40px; */\n  /* height: 40px; */\n  /* border-radius: 50%; */\n  cursor: pointer;\n  transition: var(--transition-fast);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* .MaterialPurches-removeItemButton:hover {\n  background: #e53e3e;\n  transform: scale(1.1);\n} */\n\n.MaterialPurches-orderSummary {\n  margin-top: 24px;\n  padding: 20px;\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-md);\n  border: 2px solid var(--color-success);\n}\n\n.MaterialPurches-summaryRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.MaterialPurches-summaryLabel {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.MaterialPurches-summaryValue {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--color-success);\n}\n\n/* Form Actions */\n.MaterialPurches-formActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid var(--color-border);\n}\n\n.MaterialPurches-cancelButton {\n  background: var(--color-bg-tertiary);\n  color: var(--color-text-secondary);\n  border: 2px solid var(--color-border);\n  padding: 14px 28px;\n  border-radius: var(--border-radius-sm);\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition-normal);\n}\n\n.MaterialPurches-cancelButton:hover {\n  background: var(--color-border);\n  color: var(--color-text-primary);\n}\n\n.MaterialPurches-submitButton {\n  /* background: var(--primary-gradient); */\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n  color: white;\n  border: none;\n  padding: 14px 28px;\n  border-radius: var(--border-radius-sm);\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition-normal);\n  box-shadow: var(--shadow-md);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.MaterialPurches-submitButton:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n/* Enhanced View Modal - Redesigned Simple Table View */\n.MaterialPurches-viewOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 24px;\n  backdrop-filter: blur(8px);\n}\n\n.MaterialPurches-viewContainer {\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-xl);\n  width: 100%;\n  max-width: 1000px;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: slideInUp 0.4s ease;\n}\n\n.MaterialPurches-viewHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px 32px;\n  border-bottom: 1px solid var(--color-border);\n  background: var(--card-gradient);\n  border-radius: var(--border-radius-lg) var(--border-radius-lg) 0 0;\n}\n\n.print-header {\n  flex: 1;\n}\n\n.print-title {\n  font-size: 1.75rem;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  color: var(--color-text-primary);\n}\n\n.print-subtitle {\n  font-size: 1rem;\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n.print-actions {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.MaterialPurches-printButton {\n  /* background: var(--success-gradient); */\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: var(--border-radius-sm);\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition-normal);\n  box-shadow: var(--shadow-sm);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.MaterialPurches-printButton:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.MaterialPurches-closeViewButton {\n  background: var(--color-bg-tertiary);\n  border: none;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  cursor: pointer;\n  color: var(--color-text-secondary);\n  transition: var(--transition-fast);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.MaterialPurches-closeViewButton:hover {\n  background: var(--color-border);\n  color: var(--color-text-primary);\n  transform: scale(1.05);\n}\n\n.MaterialPurches-viewContent {\n  padding: 32px;\n}\n\n/* Order Information Section */\n.order-info {\n  margin-bottom: 32px;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n.info-item {\n  display: flex;\n  align-items: center;\n  /* padding: 16px; */\n  /* background: var(--color-bg-tertiary); */\n  /* border-radius: var(--border-radius-sm); */\n  /* border-left: 4px solid var(--color-primary); */\n  flex-direction: column;\n}\n\n.info-label {\n  font-weight: 600;\n  color: var(--color-text-secondary);\n  min-width: 120px;\n  font-size: 0.9rem;\n}\n\n.info-value {\n  font-weight: 600;\n  color: var(--color-text-primary);\n  font-size: 1rem;\n}\n\n.status-badge {\n  padding: 6px 12px;\n  border-radius: var(--border-radius-xl);\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-pending {\n  background: rgba(255, 209, 102, 0.2);\n  color: #b45309;\n  border: 1px solid rgba(180, 83, 9, 0.3);\n}\n\n.status-delivered {\n  background: rgba(0, 176, 155, 0.2);\n  color: #00b09b;\n  border: 1px solid rgba(0, 176, 155, 0.3);\n}\n\n.status-cancelled {\n  background: rgba(255, 88, 88, 0.2);\n  color: #ff5858;\n  border: 1px solid rgba(255, 88, 88, 0.3);\n}\n\n.status-received {\n  background: rgba(34, 197, 94, 0.2);\n  color: #16a34a;\n  border: 1px solid rgba(34, 197, 94, 0.3);\n}\n\n.note-section {\n  text-align: start;\n}\n\n.note-title {\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin-bottom: 8px;\n  font-size: 1rem;\n}\n\n.note-content {\n  color: var(--color-text-secondary);\n  line-height: 1.6;\n  font-size: 0.95rem;\n}\n\n/* Items Table Section */\n.MaterialPurches-itemsTableSection {\n  margin-top: 32px;\n}\n\n.MaterialPurches-itemsTableTitle {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0 0 20px 0;\n  color: var(--color-text-primary);\n}\n\n.MaterialPurches-itemsTableWrapper {\n  overflow-x: auto;\n  border-radius: var(--border-radius-sm);\n  box-shadow: var(--shadow-sm);\n}\n\n.items-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: var(--color-bg-primary);\n  font-family: var(--font-primary);\n}\n\n.items-table thead {\n  background: var(--color-bg-tertiary);\n}\n\n.items-table th {\n  padding: 16px 12px;\n  text-align: left;\n  font-weight: 700;\n  color: var(--color-text-primary);\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 2px solid var(--color-border);\n}\n\n.items-table td {\n  padding: 16px 12px;\n  border-bottom: 1px solid var(--color-border);\n  color: var(--color-text-primary);\n  font-size: 0.95rem;\n  vertical-align: middle;\n}\n\n.items-table tbody tr:hover {\n  background: var(--color-bg-tertiary);\n}\n\n.MaterialPurches-materialName {\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.MaterialPurches-itemStatusSelect {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background: white;\n  border: 2px solid var(--color-border);\n  padding: 6px 24px 6px 10px;\n  border-radius: var(--border-radius-sm);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition-normal);\n  min-width: 100px;\n}\n\n.MaterialPurches-itemStatusSelect:focus {\n  outline: none;\n  /* border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1); */\n}\n\n.MaterialPurches-itemStatusSelect.status-pending {\n  color: #000000;\n  /* background: rgba(255, 209, 102, 0.1); */\n  /* border-color: rgba(180, 83, 9, 0.3); */\n}\n\n.MaterialPurches-itemStatusSelect.status-received {\n  color: #000000;\n  /* background: rgba(34, 197, 94, 0.1);\n  border-color: rgba(34, 197, 94, 0.3); */\n}\n\n.MaterialPurches-itemDeleteButton {\n  /* background: var(--color-danger); */\n  color: rgb(0, 0, 0);\n  border: none;\n  padding: 8px;\n  border-radius: var(--border-radius-sm);\n  cursor: pointer;\n  transition: var(--transition-fast);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n}\n\n.MaterialPurches-itemDeleteButton:hover {\n  /* background: #e53e3e; */\n  transform: scale(1.1);\n}\n\n.total-row {\n  background: var(--color-bg-tertiary);\n  font-weight: 700;\n  border-top: 2px solid var(--color-border);\n}\n\n.total-row td {\n  padding: 20px 12px;\n  font-size: 1.1rem;\n}\n\n/* Enhanced Table */\n.MaterialPurches-tableContainer {\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-md);\n  overflow: hidden;\n  border: 1px solid var(--color-border);\n}\n\n.MaterialPurches-tableHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 32px;\n  background: var(--card-gradient);\n  border-bottom: 1px solid var(--color-border);\n}\n\n.MaterialPurches-tableTitle {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0;\n  color: var(--color-text-primary);\n}\n\n.MaterialPurches-tableStats {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.MaterialPurches-tableStatsText {\n  font-size: 0.9rem;\n  color: var(--color-text-secondary);\n  font-weight: 500;\n}\n\n.MaterialPurches-tableWrapper {\n  overflow-x: auto;\n}\n\n.MaterialPurches-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: var(--font-primary);\n}\n\n.MaterialPurches-tableHead {\n  background: var(--color-bg-tertiary);\n}\n\n.MaterialPurches-tableHeaderCell {\n  padding: 20px 16px;\n  /* text-align: left; */\n  font-weight: 700;\n  color: var(--color-text-primary);\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 2px solid var(--color-border);\n}\n\n.MaterialPurches-tableBody .MaterialPurches-tableRow {\n  transition: var(--transition-fast);\n  border-bottom: 1px solid var(--color-border);\n}\n\n.MaterialPurches-tableBody .MaterialPurches-tableRow:hover {\n  background: var(--color-bg-tertiary);\n}\n\n.MaterialPurches-tableCell {\n  padding: 10px 16px;\n  color: var(--color-text-primary);\n  font-size: 0.95rem;\n  vertical-align: middle;\n}\n\n.MaterialPurches-poNumberCell,\n.MaterialPurches-supplierCell,\n.MaterialPurches-siteCell,\n.MaterialPurches-dateCell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: center;\n}\n\n.MaterialPurches-poNumber {\n  font-weight: 700;\n  /* color: var(--color-primary); */\n  color: #0d5787;\n  font-size: 1rem;\n}\n\n.MaterialPurches-supplierCell svg,\n.MaterialPurches-siteCell svg,\n.MaterialPurches-dateCell svg {\n  color: #ffffff;\n}\n.MaterialPurches-supplierCell {\n  /* background-color: #00b09b42; */\n  background: #14b8a6;\n  padding: 6px 0px;\n  border-radius: 50px;\n  color: #ffffff;\n  font-weight: 600;\n}\n.MaterialPurches-statusSelectWrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.MaterialPurches-statusSelect {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background: white;\n  border: 2px solid var(--color-border);\n  padding: 8px 32px 8px 12px;\n  border-radius: var(--border-radius-sm);\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition-normal);\n  min-width: 120px;\n}\n\n.MaterialPurches-statusSelect:focus {\n  outline: none;\n}\n\n.MaterialPurches-statusSelect.MaterialPurches-status-pending {\n  color: #000000;\n}\n\n.MaterialPurches-statusSelect.MaterialPurches-status-delivered {\n  color: #000000;\n}\n\n.MaterialPurches-statusSelect.MaterialPurches-status-cancelled {\n  color: #000000;\n}\n\n.MaterialPurches-statusSelectArrow {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: var(--color-text-secondary);\n}\n\n.MaterialPurches-actionsCell {\n  white-space: nowrap;\n}\n\n.MaterialPurches-actionButtons {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.MaterialPurches-viewButton,\n.MaterialPurches-editButton,\n.MaterialPurches-deleteButton {\n  padding: 10px;\n\n  border-radius: var(--border-radius-sm);\n  cursor: pointer;\n  transition: var(--transition-fast);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n}\n\n.MaterialPurches-viewButton {\n  /* background: var(--color-info); */\n  outline: none;\n  border: none;\n  background: rgba(59, 130, 246, 0.1);\n  color: #10b981;\n  background: #10b98141;\n}\n\n.MaterialPurches-viewButton:hover {\n  background: #10b981;\n  transform: translateY(-2px);\n  /* box-shadow: var(--shadow-sm); */\n  border-color: red;\n  color: white;\n}\n\n.MaterialPurches-editButton {\n  /* background: var(--color-warning); */\n  color: #3b82f6;\n  outline: none;\n  border: none;\n  background: rgba(59, 131, 246, 0.274);\n}\n\n.MaterialPurches-editButton:hover {\n  background: #3b82f6;\n  transform: translateY(-2px);\n  color: white;\n  /* box-shadow: var(--shadow-sm); */\n}\n\n.MaterialPurches-deleteButton {\n  /* background: var(--color-danger); */\n  color: #ef4444;\n  outline: none;\n  border: none;\n  background: #ef444444;\n}\n\n.MaterialPurches-deleteButton:hover {\n  background: #ef4444;\n  transform: translateY(-2px);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.MaterialPurches-noData {\n  text-align: center;\n  padding: 80px 20px;\n}\n\n.MaterialPurches-noDataContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  color: var(--color-text-secondary);\n}\n\n.MaterialPurches-noDataIcon {\n  color: var(--color-text-tertiary);\n  opacity: 0.5;\n}\n\n.MaterialPurches-noDataText h3 {\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin: 0 0 8px 0;\n  color: var(--color-text-secondary);\n}\n\n.MaterialPurches-noDataText p {\n  font-size: 0.95rem;\n  margin: 0;\n  color: var(--color-text-tertiary);\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .MaterialPurches-headerContent {\n    flex-direction: column;\n    gap: 24px;\n    text-align: center;\n  }\n}\n\n@media (max-width: 768px) {\n  .MaterialPurches-container {\n    /* padding: 16px; */\n  }\n\n  .MaterialPurches-header {\n    padding: 24px 20px;\n  }\n\n  .MaterialPurches-title {\n    font-size: 2rem;\n  }\n\n  .MaterialPurches-headerSection {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .MaterialPurches-searchContainer {\n    max-width: none;\n  }\n\n  .MaterialPurches-formGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .MaterialPurches-orderItemRow {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .info-grid {\n    /* grid-template-columns: 1fr; */\n  }\n\n  .MaterialPurches-actionButtons {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .MaterialPurches-formActions {\n    flex-direction: column;\n  }\n\n  .MaterialPurches-tableHeader {\n    flex-direction: column;\n    gap: 16px;\n    align-items: flex-start;\n  }\n\n  .items-table {\n    font-size: 0.85rem;\n  }\n\n  .items-table th,\n  .items-table td {\n    padding: 12px 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .MaterialPurches-header {\n    padding: 20px 16px;\n  }\n\n  .MaterialPurches-title {\n    font-size: 1.8rem;\n  }\n\n  .MaterialPurches-subtitle {\n    font-size: 0.95rem;\n  }\n\n  .MaterialPurches-formOverlay,\n  .MaterialPurches-viewOverlay {\n    padding: 16px;\n  }\n\n  .MaterialPurches-form,\n  .MaterialPurches-viewContent {\n    padding: 24px;\n  }\n\n  .MaterialPurches-tableHeaderCell,\n  .MaterialPurches-tableCell {\n    padding: 12px 8px;\n    font-size: 0.85rem;\n  }\n\n  .MaterialPurches-actionButtons {\n    flex-direction: row;\n    gap: 4px;\n  }\n\n  .MaterialPurches-viewButton,\n  .MaterialPurches-editButton,\n  .MaterialPurches-deleteButton {\n    width: 36px;\n    height: 36px;\n  }\n\n  .print-actions {\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n\n/* Print Styles */\n@media print {\n  .print-actions {\n    display: none !important;\n  }\n\n  .MaterialPurches-itemDeleteButton {\n    display: none !important;\n  }\n\n  .MaterialPurches-actionsCell {\n    display: none !important;\n  }\n\n  .MaterialPurches-tableHeaderCell:nth-child(6) {\n    display: none !important;\n  }\n\n  .items-table th:last-child,\n  .items-table td:last-child {\n    display: none !important;\n  }\n\n  body {\n    background: white !important;\n  }\n\n  .MaterialPurches-viewContainer {\n    box-shadow: none !important;\n    border: 1px solid #ddd !important;\n  }\n}\n\n.Site_name {\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-weight: 500;\n  display: inline-block;\n  background-color: #00b09b;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
